import React from 'react'
import {Page, Text, View, Document, StyleSheet, Image, Font} from '@react-pdf/renderer'
import logo from '../../../../../_websoft/assets/images/logo.jpg'

// FONT REGISTER
let fontRegistered = false
if (!fontRegistered) {
    Font.register({
        family: 'Roboto',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
    })
    fontRegistered = true
}

interface Props {
    pregledData: any[]
    kupac: string
}

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        padding: 20,
        paddingBottom: 40, // space for footer
        fontFamily: 'Roboto',
        fontSize: 11,
    },

    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10,
    },

    logo: {
        width: 140,
    },

    title: {
        fontSize: 14,
        fontWeight: 'bold',
    },

    // 🔥 NEW: 2 COLUMN HEADER
    infoWrapper: {
        flexDirection: 'row',
        marginBottom: 10,
    },

    infoCol: {
        width: '50%',
    },

    row: {
        flexDirection: 'row',
        marginBottom: 3,
    },

    label: {
        width: '45%',
        fontWeight: 'bold',
    },

    value: {
        width: '55%',
    },

    paketWrapper: {
        marginBottom: 6,
        borderWidth: 1,
    },

    leftBox: {
        width: '30%',
        padding: 5,
        borderRightWidth: 1,
    },

    rightBox: {
        width: '70%',
    },

    tableHeader: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        backgroundColor: '#eee',
    },

    headerCell: {
        flex: 1,
        padding: 4,
        fontWeight: 'bold',
        textAlign:'center'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        alignItems: 'stretch',
    },

    cell: {
        flex: 1,
        paddingVertical: 4,
        paddingHorizontal: 5,
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 18,
    },

    bold: {
        fontWeight: 'bold',
    },

    // 🔥 FOOTER
    footer: {
        position: 'absolute',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: 'gray',
    },
})

const KupciPregledPdf: React.FC<Props> = ({pregledData, kupac}) => {
    return (
        <Document>
            {pregledData.map((data, index) => (
                <Page key={index} size='A4' orientation='landscape' style={styles.page}>

                    {/* HEADER */}
                    <View style={styles.header}>
                        <Image src={logo} style={styles.logo} />
                        <Text style={styles.title}>Pregled</Text>
                    </View>

                    {/* 🔥 TWO COLUMN INFO */}
                    <View style={styles.infoWrapper}>
                        {/* LEFT COLUMN */}
                        <View style={styles.infoCol}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Kupac:</Text>
                                <Text style={styles.value}>{kupac}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Broj naloga:</Text>
                                <Text style={styles.value}>
                                    {data?.brojNaloga} ({data?.stavka})
                                </Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Vrsta:</Text>
                                <Text style={styles.value}>{data?.vrsta}</Text>
                            </View>
                        </View>

                        {/* RIGHT COLUMN */}
                        <View style={styles.infoCol}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Krajnji kupac:</Text>
                                <Text style={styles.value}>{data?.krajnjiKupac}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Broj ponude:</Text>
                                <Text style={styles.value}>{data?.brojPonude}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Boja:</Text>
                                <Text style={styles.value}>{data?.boja}</Text>
                            </View>
                        </View>
                    </View>

                    {/* PAKETI */}
                    {data?.paketi?.map((paket: any, pIndex: number) => (
                        <View key={pIndex} style={styles.paketWrapper}>
                            <View style={{flexDirection: 'row'}}>

                                <View style={styles.leftBox}>
                                    <Text style={styles.bold}>Paket: {paket.paket}</Text>
                                    <Text>Dimenzije: {paket.gabarit}</Text>
                                </View>

                                <View style={styles.rightBox}>
                                    <View style={styles.tableHeader}>
                                        <Text style={styles.headerCell}>Dužina</Text>
                                        <Text style={styles.headerCell}>Količina</Text>
                                        <Text style={styles.headerCell}>Status</Text>
                                        <Text style={styles.headerCell}>Isporučen</Text>
                                    </View>

                                    {paket.rows.map((row: any, rIndex: number) => (
                                        <View key={rIndex} style={styles.tableRow}>
                                            <View style={styles.cell}>
                                                <Text>{row.duzina}</Text>
                                            </View>

                                            <View style={styles.cell}>
                                                <Text>{row.kvadratura}</Text>
                                            </View>

                                            <View style={[styles.cell, {backgroundColor: row.statusBoja}]}>
                                                <Text>{row.status}</Text>
                                            </View>

                                            <View style={[styles.cell, {backgroundColor: row.isporucenBoja2}]}>
                                                <Text>Ne</Text>
                                            </View>
                                        </View>
                                    ))}
                                </View>
                            </View>
                        </View>
                    ))}

                    {/* TOTAL */}
                    <View style={{marginTop: 5, alignItems: 'flex-end'}}>
                        <Text style={styles.bold}>Ukupno: {data?.ukupno}</Text>
                    </View>

                    {/* 🔥 PAGE NUMBER */}
                    <Text
                        style={styles.footer}
                        render={({pageNumber, totalPages}) =>
                            `Stranica ${pageNumber} / ${totalPages}`
                        }
                        fixed
                    />

                </Page>
            ))}
        </Document>
    )
}

export default KupciPregledPdf